import React, { useEffect, useState } from "react";
import Papa from "papaparse";
import ReactECharts from "echarts-for-react";
import { grey } from "@mui/material/colors";
import exportacoesCSV from "../utils/data/exportacoes1990_2025.csv";
const monthNames = [
  "jan.",
  "fev.",
  "mar.",
  "abr.",
  "mai",
  "jun.",
  "jul.",
  "ago.",
  "set.",
  "out.",
  "nov.",
  "dez.",
];
const ExportacoesChart = ({ projecoes }) => {
  const BLUE = "#6ecaff";
  const GREEN = "#008000";
  const GRAY = grey[400] || "#999999";

  const [meses, setMeses] = useState([]);
  const [conillon, setConillon] = useState([]);
  const [arabica, setArabica] = useState([]);
  const [soluvel, setSoluvel] = useState([]);
  const [dataZoomRange, setDataZoomRange] = useState({ start: 0, end: 100 });

  const parseNumber = (str) => {
    if (!str) return 0;
    const cleaned = str.replace(/\./g, "").replace(",", ".");
    const num = Number(cleaned);
    return isNaN(num) ? 0 : num;
  };

  const getYear = (mesAno) => {
    const parts = mesAno.split("-");
    if (parts.length !== 2) return 0;
    const yearPart = parts[1];
    const yNum = Number(yearPart);
    if (isNaN(yNum)) return 0;
    return yearPart.length === 4
      ? yNum
      : yNum <= 25
        ? 2000 + yNum
        : 1900 + yNum;
  };

  useEffect(() => {
    fetch(exportacoesCSV)
      .then((res) => res.text())
      .then((csvText) => {
        const parsed = Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
        });
        const data = parsed.data;

        const mesesArr = [];
        const conArr = [];
        const araArr = [];
        const solArr = [];

        data.forEach((row) => {
          const mesCompleto = row["Mes/Ano"]?.trim();
          if (!mesCompleto) return;

          mesesArr.push(mesCompleto);
          conArr.push(parseNumber(row["Conillon"]));
          araArr.push(parseNumber(row["Arabica"]));
          solArr.push(parseNumber(row["Soluvel"]));
        });

        const startIndex = mesesArr.findIndex((m) => getYear(m) >= 2022);
        const endIndex =
          mesesArr.findIndex((m) => getYear(m) > 2025) - 1 >= 0
            ? mesesArr.findIndex((m) => getYear(m) > 2025) - 1
            : mesesArr.length - 1;

        const total = mesesArr.length;
        const startPercent = startIndex >= 0 ? (startIndex / total) * 100 : 0;
        const endPercent = endIndex >= 0 ? ((endIndex + 1) / total) * 100 : 100;

        if (
          projecoes &&
          projecoes.arabica &&
          projecoes.conilon &&
          projecoes.soluvel
        ) {
          const now = new Date();
          const mesProj = `${monthNames[now.getMonth()]}-${String(now.getFullYear()).slice(-2)}`;
          mesesArr.push(mesProj);
          araArr.push(projecoes.arabica);
          conArr.push(projecoes.conilon);
          solArr.push(projecoes.soluvel);
        }

        setMeses(mesesArr);
        setConillon(conArr);
        setArabica(araArr);
        setSoluvel(solArr);
        setDataZoomRange({ start: startPercent, end: endPercent });
      });
  }, [projecoes]);

  const option = {
    title: {
      text: "Exportações de Café",
      left: "center",
      textStyle: { color: GRAY },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: (params) => {
        let tooltip = `${params[0].axisValue}<br/>`;
        let total = 0;
        params.forEach((item) => {
          tooltip += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:${item.color};"></span> ${item.seriesName}: ${Math.round(item.data).toLocaleString("pt-BR")}<br/>`;
          total += item.data;
        });
        tooltip += `<strong>Total: ${Math.round(total).toLocaleString("pt-BR")}</strong>`;
        return tooltip;
      },
    },
    legend: {
      top: 30,
      data: ["Arabica", "Conillon", "Solúvel"],
      textStyle: { color: GRAY },
      icon: "circle",
    },
    grid: { left: "10%", right: "10%", bottom: "15%", containLabel: true },
    xAxis: {
      type: "category",
      data: meses,
      axisLabel: {
        interval: 5,
        rotate: 45,
        color: GRAY,
      },
      axisLine: { lineStyle: { color: GRAY } },
    },
    yAxis: {
      type: "value",
      name: "Sacos",
      axisLine: { lineStyle: { color: GRAY } },
      axisLabel: { color: GRAY },
      splitLine: { lineStyle: { color: "#ddd" } },
    },
    series: [
      {
        name: "Arabica",
        type: "bar",
        stack: "total",
        data: arabica,
        itemStyle: { color: GRAY },
        barMaxWidth: 16,
      },
      {
        name: "Conillon",
        type: "bar",
        stack: "total",
        data: conillon,
        itemStyle: { color: BLUE },
        barMaxWidth: 16,
      },
      {
        name: "Solúvel",
        type: "bar",
        stack: "total",
        data: soluvel,
        itemStyle: { color: GREEN },
        barMaxWidth: 16,
      },
    ],
    toolbox: {
      feature: {
        saveAsImage: {},
        dataZoom: {},
        restore: {},
      },
      iconStyle: { borderColor: GRAY },
      emphasis: { iconStyle: { borderColor: BLUE } },
    },
    dataZoom: [
      {
        type: "slider",
        start: dataZoomRange.start,
        end: dataZoomRange.end,
      },
    ],
    graphic: {
      elements: [
        {
          type: "text",
          left: "center",
          top: "80px",
          style: {
            text: "cafetrade.com.br",
            fontSize: 30,
            fontWeight: "bold",
            fill: "rgba(200, 200, 200, 0.3)",
          },
          z: -10,
        },
      ],
    },
  };

  return (
    <ReactECharts
      option={option}
      style={{ height: 500, width: "100%", marginTop: 24 }}
      notMerge={true}
    />
  );
};

export default ExportacoesChart;
